import { Injectable } from "@angular/core";
import { MapperInterface } from "../mapper-inteface";
import { RecapitoDTO } from "@app/shared/dto/anagrafe/recapitoDTO";
import { RecapitoVO } from "@app/shared/vo/gescor/recapitoVO";

@Injectable({
  providedIn: "root"
})
export class MapperRecapito
  implements MapperInterface<RecapitoDTO, RecapitoVO> {
  convertVoToDto(recapitoVO: RecapitoVO): RecapitoDTO {
    let recapitoDTO = new RecapitoDTO();
    recapitoDTO.denominazioneRecapito = recapitoVO.denominazioneRecapito;
    recapitoDTO.denominazioneSoggetto = recapitoVO.denominazioneSoggetto;
    recapitoDTO.idRecapito = recapitoVO.idRecapito;
    recapitoDTO.idSoggetto = recapitoVO.idSoggetto;
    recapitoDTO.tipoDestinatario = recapitoVO.tipoRecapito;
    recapitoDTO.tipoRecapito = recapitoVO.tipo;
    return recapitoDTO || new RecapitoDTO();
  }
  convertDtoToVo(recapitoDTO: RecapitoDTO): RecapitoVO {
    let recapitoVO = new RecapitoVO();
    recapitoVO.denominazioneRecapito = recapitoDTO.denominazioneRecapito;
    recapitoVO.denominazioneSoggetto = recapitoDTO.denominazioneSoggetto;
    recapitoVO.idRecapito = recapitoDTO.idRecapito;
    recapitoVO.idSoggetto = recapitoDTO.idSoggetto;
    recapitoVO.tipoRecapito = recapitoDTO.tipoDestinatario;
    recapitoVO.tipo = recapitoDTO.tipoRecapito;
    return recapitoVO || new RecapitoVO();
  }
  convertListVoToDto(recapitoVOList: RecapitoVO[]): RecapitoDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(recapitoDTOList: RecapitoDTO[]): RecapitoVO[] {
    throw new Error("Method not implemented.");
  }
}
